import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

export const useFilteredPackages = () => {
  const { packsList, publishedRooms, isLoading } =
    useContext(ModernHotelContext);

  const filteredNightStayPacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isPublished = pack.status === ExtranetPackStatus.PUBLISHED;
      const isNightStay = !pack.isDaytime;

      const hasPublishedRoom = (pack.packRooms ?? []).some((packRoom) =>
        publishedRooms.some((room) => room.id === packRoom.roomId)
      );

      return isPublished && isNightStay && hasPublishedRoom;
    });
  }, [packsList, publishedRooms]);

  const filteredDaytimePacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isPublished = pack.status === ExtranetPackStatus.PUBLISHED;
      const isDaytime = pack.isDaytime;

      return isPublished && isDaytime;
    });
  }, [packsList]);

  return {
    filteredNightStayPacks,
    filteredDaytimePacks,
    isLoading,
  };
};
